import { computed } from 'vue';
import { createQueryParams } from '@/utils/query-params';

export function useFilters(
  filters: Record<string, Date | string | number | boolean | undefined | string[] | number[]>,
) {
  return computed(() => createQueryParams(filters));
}
